// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"300609ab8dc0634a","631":"168ea89485e30a9b","952":"a7f2a321e42870a2"}[chunkId] + ".js";
};